import { validateEmail } from "../../libs/validators";

export class PasswordResetPage {

  constructor(containerId = null) {
    this.containerNode = containerId ? document.getElementById(containerId) : null;

    if (!this.containerNode) {
      return;
    }

    this.init();
  }

  init() {
    const form = this.containerNode.querySelector('#password-reset-form');

    if (form) {
      form.addEventListener('submit', (event) => {
        const emailInput = form.querySelector('input[name="email"]');
        if (emailInput) {
          const emailValue = emailInput.value.trim();
          if (!emailValue) {
            event.preventDefault();
            const errorNode = form.querySelector('.field-error');
            if (errorNode) {
              errorNode.textContent = 'Please enter your email address.';
            }
          } else if (!validateEmail(emailValue)) {
            event.preventDefault();
            const errorNode = form.querySelector('.field-error');
            if (errorNode) {
              errorNode.textContent = 'Please enter a valid email address.';
            }
          }
        }
      });
    }
  }
}